import { Role } from "./role";
import { UserInfo } from "./user-info";

export class User {
    token_data?: {
      access_token: string;
      expires_in: number;
      refresh_token: string;
      token_type: string
    };
    user: UserInfo;
}
